import styled from 'styled-components';
import { Theme } from '@/styles/theme';
import { PaddingProps } from '@/types/ui';

interface ContainerProps {
  $padding: PaddingProps;
  $rounded?: keyof Theme['rounded'];
  $gap?: keyof Theme['gap'];
  $textSize?: keyof Theme['size'];
  $fontWeight?: keyof Theme['font'];
}

const Input = styled.input<ContainerProps>`
  padding: ${(p) =>
    typeof p.$padding === 'object'
      ? `${p.theme.size[p.$padding.y]} ${p.theme.size[p.$padding.x]}`
      : p.theme.size[p.$padding]};
  background-color: rgba(255, 255, 255, 0.08);
  color: ${(p) => p.theme.colors.textWhite};
  backdrop-filter: blur(4px);
  ${(p) => p.theme.gap[p.$gap ?? 'zero']};
  font-size: ${(p) => p.theme.size[p.$textSize ?? 'md']};
  ${(p) => p.theme.font[p.$fontWeight ?? 'regular']};
  display: flex;
  align-items: center;
  ${(p) => p.theme.rounded[p.$rounded ?? 'md']};
  border: 1px solid transparent;
  ${(p) => p.theme.transition.default};

  &::placeholder {
    color: ${(p) => p.theme.colors.textGray};
  }

  &:focus {
    border: 1px solid ${(p) => p.theme.colors.point};
    outline: none;
  }
`;

export default Input;
